<table border="0" cellpadding="4" cellspacing="4" style="width: 99%; margin: 0 auto;">
  <tbody>
    <tr *ngIf="error">
      <td>
        <div id="errors">
          <br><br>
          <b>
            <font color="red">{{ error }}</font>
          </b>
        </div>
      </td>
    </tr>

    <tr *ngIf="loading && !event">
      <td align="center">
        <p>Loading event information...</p>
      </td>
    </tr>

    <tr>
      <td id="thank-you">
        <p>
          <strong>Thank you for registering for the <i>SHARE Nurse Training</i> Speaker Program as detailed below.</strong>
        </p>
      </td>
    </tr>

    <tr *ngIf="event && !loading">
      <td>
        <b>Program Title: </b>
        <span>{{ event.topic }}</span>
        <br>
        <b>Speaker:</b>
        <span *ngIf="event.speaker">
          {{ event.speaker.full_name }},
          {{ event.speaker.degrees }}
        </span>
        <span *ngIf="!event.speaker">N/A</span>
        <br/>

        <b>Date:</b>
        {{ event.friendly_date }}<br/>
        <b>Time:</b>
        <span *ngIf="event.meeting_type && !event.meeting_type.includes('Virtual')">
          {{ event.start_time }} {{ event.timezone }}<br/>
        </span>
        <span *ngIf="event.meeting_type && event.meeting_type.includes('Virtual')">
          {{ formatEventTime() }}<br>
        </span>
        <span *ngIf="event.meeting_type && event.meeting_type.includes('Virtual')">
          <br>
          <strong *ngIf="event.webcast_link">
            If this virtual program is currently taking place, please 
            <b><a style="text-decoration: underline" [href]="event.webcast_link" target="_blank">click here</a></b> 
            for immediate access.
          </strong>
          <br><br>
        </span>
      </td>
    </tr>

    <tr>
      <td>
        <p>
          An email confirming your registration will be sent to the email address you provided. If you do not receive a confirmation email within 48 hours of registering, please contact a Program Manager at <a href="mailto:CSL.Program@trio-hc.com">CSL.Program@trio-hc.com</a>.
        </p>
        <p>
          <i>
            As of January 1, 2022, PhRMA Code prohibits its members from providing alcoholic beverages at speaker programs, if applicable. Additionally, the wait staff cannot take your order for alcohol. You are, however, welcome to purchase your own drink at the bar and bring it into the meeting room. We appreciate your understanding.
          </i>
        </p>
      </td>
    </tr>
  </tbody>
</table>
